import {BoilerPriceApiDto, JobProfitApiDto} from "../../api/model/rest";
import Price from "../common/Price";
import {none, option, Option, some} from "ts-option";
import Amount from "../common/Amount";

/**
 * Job profit object.
 */
export default class JobProfit {
	constructor(
		public readonly margin: Price,
		public readonly parts: Option<Price>,
		public readonly rebate: Price,
		public readonly sum: Option<Price>,
		public readonly boilerPrice: BoilerPrice
	) {}

	static fromJson(json: JobProfitApiDto): JobProfit {
		const margin = Price.fromJson(json.margin);
		const parts = json.parts ? option(Price.fromJson(json.parts)) : none;
		const rebate = Price.fromJson(json.rebate);
		const sum = json.sum ? option(Price.fromJson(json.sum)) : none;
		const boilerPrice = BoilerPrice.fromJson(json.boilerPrice);
		return new JobProfit(margin, parts, rebate, sum, boilerPrice);
	}
}

export enum BoilerPriceStatus {
	KNOWN = "KNOWN",
	UNKNOWN = "UNKNOWN",
	NO_BOILER = "NO_BOILER"
}

class BoilerPrice {
	constructor(
		public readonly status: string, // BoilerPriceStatus
		public readonly boilerPrice: Option<Amount>
	) {}

	static fromJson(json: BoilerPriceApiDto) {
		return new BoilerPrice(json.status, option(json.boilerPrice).map(Amount.fromPounds));
	}
}